import { watchEffect, onBeforeUnmount } from 'vue';

const HIDE_SUPPORT_WIDGET_CLASS = 'jbai-hide-support-widget';

// Module-level so multiple independent callers (e.g. JobDetails and UnableToTailorModal on
// the same page) can each request the widget hidden without one caller's "false" clobbering
// another caller's "true".
let hideRequestCount = 0;

const updateWidgetVisibility = () => {
	document.body.classList.toggle(HIDE_SUPPORT_WIDGET_CLASS, hideRequestCount > 0);
};

export function useHideSupportWidget(shouldHide) {
	let isHiding = false;

	watchEffect(() => {
		const nextIsHiding = !!shouldHide();
		if (nextIsHiding === isHiding) {
			return;
		}

		isHiding = nextIsHiding;
		hideRequestCount += isHiding ? 1 : -1;
		updateWidgetVisibility();
	});

	onBeforeUnmount(() => {
		if (!isHiding) {
			return;
		}

		isHiding = false;
		hideRequestCount -= 1;
		updateWidgetVisibility();
	});
}
